"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Breadcrumb = void 0;
var _reactRouterDom = require("react-router-dom");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Breadcrumb = (param)=>{
    let { path, title } = param;
    const { translations } = (0, _hooks.useTranslations)();
    const location = (0, _reactRouterDom.useLocation)();
    const isActiveModifier = location.pathname === path;
    const getBreadcrumbType = ()=>{
        if (title === _models.TranslationKey.search || title === _models.TranslationKey.supportCenter) {
            return translations[title];
        }
        return title;
    };
    if (isActiveModifier) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BreadcrumbsActiveRoot, {
            children: getBreadcrumbType()
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BreadcrumbRoot, {
        to: path,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Name, {
            children: getBreadcrumbType()
        })
    });
};
exports.Breadcrumb = Breadcrumb;
